module.exports = __webpack_public_path__ + "static/honorable-6ffd798db65f3e8132eba832011f87a9.jpg";